export const positionFromCenter = (lm: number, v: number, way: number) => {
  switch (way) {
    case 0:
      return [lm, lm - v]
    case 1:
      return [lm + v * Math.cos((Math.PI / 180) * 18), lm - v * Math.sin((Math.PI / 180) * 18)]
    case 2:
      return [lm + v * Math.sin((Math.PI / 180) * 36), lm + v * Math.cos((Math.PI / 180) * 36)]
    case 3:
      return [lm - v * Math.sin((Math.PI / 180) * 36), lm + v * Math.cos((Math.PI / 180) * 36)]
    case 4:
      return [lm - v * Math.cos((Math.PI / 180) * 18), lm - v * Math.sin((Math.PI / 180) * 18)]
    default:
      return [lm, lm]
  }
}

export const positionFromCenterQuad = (lm: number, v: number, way: number) => {
  switch (way) {
    case 0:
      return [lm, lm - v]
    case 1:
      return [lm + v * 0.91, lm]
    case 2:
      return [lm, lm + v * 0.91]
    case 3:
      return [lm - v * 0.91, lm]
    default:
      return [lm, lm]
  }
}
